import { render, staticRenderFns } from "./make-paydoc-template.vue?vue&type=template&id=f566dba8&"
import script from "./make-paydoc-template.vue?vue&type=script&lang=js&"
export * from "./make-paydoc-template.vue?vue&type=script&lang=js&"
import style0 from "./make-paydoc-template.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "make-paydoc-template.vue"
export default component.exports